const GENERIC_HTTP_MESSAGES = new Set([
  'Bad Request',
  'Unauthorized',
  'Forbidden',
  'Not Found',
  'Unprocessable Content',
  'Internal Server Error',
  'Bad Gateway',
  'Service Unavailable',
  'Gateway Timeout',
])

export const LOGIN_ERROR_INCORRECT_CREDENTIALS = 'Incorrect email or password'
export const LOGIN_ERROR_ACCOUNT_LOCKED =
  'Account locked. Please contact an administrator.'
export const LOGIN_ERROR_TECH_ISSUE =
  'A technical issue occurred. Please contact an administrator.'
export const LOGIN_ERROR_VALIDATION =
  'Please check your email and password and try again.'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function readNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed ? trimmed : null
}

function extractDetail(error: unknown): string | null {
  if (!isRecord(error)) {
    return readNonEmptyString(error)
  }

  if (isRecord(error.body)) {
    const detail = readNonEmptyString(error.body.detail)
    if (detail) {
      return detail
    }
  }

  if (isRecord(error.response)) {
    if (isRecord(error.response.data)) {
      const detail = readNonEmptyString(error.response.data.detail)
      if (detail) {
        return detail
      }
    }
    const detail = readNonEmptyString(error.response.detail)
    if (detail) {
      return detail
    }
  }

  return readNonEmptyString(error.message)
}

export function loginErrorMessage(error: unknown): string {
  const detail = extractDetail(error)
  if (!detail || GENERIC_HTTP_MESSAGES.has(detail)) {
    return LOGIN_ERROR_TECH_ISSUE
  }

  const lower = detail.toLowerCase()
  if (lower.includes('locked')) {
    return LOGIN_ERROR_ACCOUNT_LOCKED
  }
  if (lower.includes('incorrect email or password')) {
    return LOGIN_ERROR_INCORRECT_CREDENTIALS
  }
  if (detail === 'Validation Error') {
    return LOGIN_ERROR_VALIDATION
  }

  return LOGIN_ERROR_TECH_ISSUE
}
